export default __webpack_public_path__ + "static/media/delete.d38d157f.svg";